var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgRank10 = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 110,
  height: 103,
  viewBox: "0 0 110 103",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_ddd_1_383)"
}, /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter1_d_1_383)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M23.924 76L32.37 35H20.808L22.448 27.292H23.514C27.45 27.292 30.7027 26.554 33.272 25.078C35.896 23.602 37.8367 21.224 39.094 17.944H47.786L35.732 76H23.924ZM50.5304 48.94C51.3504 44.9493 52.2798 41.0953 53.3184 37.378C54.4118 33.606 55.8604 30.2987 57.6644 27.456C59.4684 24.5587 61.7644 22.2627 64.5524 20.568C67.3404 18.8187 70.8938 17.944 75.2124 17.944C80.2418 17.944 83.8498 19.01 86.0364 21.142C88.2778 23.2193 89.3984 26.6633 89.3984 31.474C89.3984 33.442 89.2344 35.656 88.9064 38.116C88.5784 40.5213 88.1138 43.2 87.5124 46.152C86.6924 50.1973 85.7631 54.0787 84.7244 57.796C83.6858 61.5133 82.2644 64.8207 80.4604 67.718C78.6564 70.5607 76.3604 72.8567 73.5724 74.606C70.7844 76.3007 67.2311 77.148 62.9124 77.148C57.8831 77.148 54.2478 76.082 52.0064 73.95C49.7651 71.818 48.6444 68.292 48.6444 63.372C48.6444 61.4587 48.8084 59.3267 49.1364 56.976C49.4644 54.5707 49.9291 51.892 50.5304 48.94ZM61.8464 51.482C60.6438 57.1673 60.0424 61.3767 60.0424 64.11C60.0424 66.1873 60.3978 67.6087 61.1084 68.374C61.8191 69.0847 62.9398 69.44 64.4704 69.44C65.7824 69.44 66.9031 69.1393 67.8324 68.538C68.8164 67.882 69.6911 66.816 70.4564 65.34C71.2764 63.8093 72.0418 61.7867 72.7524 59.272C73.4631 56.7573 74.2011 53.6413 74.9664 49.924L76.2784 43.61C77.4811 37.9247 78.0824 33.7427 78.0824 31.064C78.0824 28.9867 77.6998 27.5653 76.9344 26.8C76.2238 26.0347 75.1031 25.652 73.5724 25.652C72.2604 25.652 71.1124 25.98 70.1284 26.636C69.1991 27.2373 68.3518 28.3033 67.5864 29.834C66.8211 31.31 66.0831 33.3053 65.3724 35.82C64.6618 38.3347 63.9238 41.4507 63.1584 45.168L61.8464 51.482Z",
  fill: "#FAFAFA"
})))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_ddd_1_383",
  x: -11,
  y: 0.94397,
  width: 120.398,
  height: 101.204,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 5
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 10
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_1_383"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 9
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect1_dropShadow_1_383",
  result: "effect2_dropShadow_1_383"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 6
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 5
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect2_dropShadow_1_383",
  result: "effect3_dropShadow_1_383"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect3_dropShadow_1_383",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter1_d_1_383",
  x: 16.8081,
  y: 17.944,
  width: 76.5903,
  height: 67.204,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 4
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_1_383"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_1_383",
  result: "shape"
})))));
export default SvgRank10;